import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ResourceOptions.css";
import { API_URL } from "../../utils/auth";

const images = [
  "newUserOnboardingMiniCourse.jpg",
  "exceptionalExperienceCourse.jpg",
  "knowledgeBase.jpg",
  "retentionCalculator.jpg"
];

const idOrder = [4, 5, 6];

const ResourceOptions = () => {
  const [lessons, setLessons] = useState([]);
  const [clicked, setClicked] = useState([false, false, false, false]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLessons = async () => {
      try {
        const response = await axios.get(`${API_URL}/lesson/lessons`);
        
        const sortedLessons = idOrder.map(id =>
          response.data.find(lesson => lesson.id === id) || {}
        );

        sortedLessons.forEach(lesson => {
          lesson.enabled = true;
        });

        sortedLessons.push({
          id: "retention-calculator",
          title: "Retention Calculator",
          enabled: true
        });

        setLessons(sortedLessons);
      } catch (error) {
        console.error("Error fetching lessons:", error);
      }
    };

    fetchLessons();
  }, []);

  const handleClick = (index) => {
    const lesson = lessons[index];
    const newClicked = [...clicked];
    newClicked[index] = !newClicked[index];
    setClicked(newClicked);

    switch(index) {
      case 0: 
        navigate(`/lesson-list-mini-course/${lesson.id}`);
        break;
      case 1: 
        navigate(`/lesson-list/${lesson.id}`);
        break;
      case 2:
        navigate(`/knowledge-base`);
        break;
      case 3:
        navigate("/resource-retention-calculator");
        break;
      default:
        break;
    }
  };

  return (
    <div className="buttons-resource">
      {lessons.map((lesson, index) => (
        <div key={lesson.id || index} className="button-container">
          <button
            onClick={() => handleClick(index)}
            className={`button-resource ${clicked[index]}`}
          >
            <img src={images[index]} alt={lesson.title} className="size-buttom" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ResourceOptions;